'use memo'

import {
  AgxColumn,
  AgxRow,
  AgxTypography,
  AgxDivider,
  AgxToggleSwitch,
  AgxCommissionPlan,
  AgxNotificationBox,
} from '@urbanx/agx.ui-components2'
import { CommissionDetails } from '@urbanx/agx.campaigns.client'
import { TaskStepDto } from '@urbanx/agx.activities.client'
import { hasBelowMinimumCommission } from './commissionMinimumAlert'

export const AgreementCommissionStageSteps = ({
  commissionDetails,
  onCommissionUpdated,
  setCommissionDetailsValid,
  allowedCommissionTypes,
  currentCommissionInfo,
  tasksStage: tasksStage,
  updateTaskStep: updateTaskStep,
}: {
  commissionDetails?: CommissionDetails
  onCommissionUpdated: (updated: { value: CommissionDetails }) => void
  setCommissionDetailsValid: (valid: boolean) => void
  allowedCommissionTypes: any[]
  currentCommissionInfo?: CommissionDetails
  tasksStage: TaskStepDto[]
  updateTaskStep: (step: TaskStepDto, isChecked: boolean) => void
}) => {
  const commissionTask = tasksStage[0]
  const signatureTask = tasksStage[1]
  const selectedCommissionDetails = commissionDetails ?? currentCommissionInfo

  return (
    <AgxColumn gap="spacing-xl" fill>
      {commissionTask && (
        <AgxRow
          gap="spacing-lg"
          justifyContent="space-between"
          alignItems="flex-start"
          fill
        >
          <AgxRow justifyContent="left" alignItems="flex-start">
            <AgxTypography
              id="commissionCompleted"
              type="body_ui"
              size="small"
            >
              Commission is completed
            </AgxTypography>
          </AgxRow>

          <AgxRow justifyContent="right" alignItems="flex-start">
            <AgxToggleSwitch
              id="commission-completed-step"
              checked={commissionTask.isCompleted ?? false}
              onChange={(isChecked: boolean) =>
                updateTaskStep(commissionTask, isChecked)
              }
            />
          </AgxRow>
        </AgxRow>
      )}

      <AgxCommissionPlan
        id={'commissionPlan'}
        commissionTypes={allowedCommissionTypes}
        onValueChanged={onCommissionUpdated}
        formName={'Agency Agreement'}
        defaultValue={selectedCommissionDetails}
        required
        validateCommissionTypeSelection
        commissionTypeSelectionErrorText="Please select a commission option"
        showCommissionRangeDisclaimer
        onValidateStatusChange={setCommissionDetailsValid}
      />

      {hasBelowMinimumCommission(selectedCommissionDetails) && (
        <AgxNotificationBox
          type="warning"
          heading=""
          body="Commission rate is low. Alert Admin Manager and confirm rate is correct before proceeding."
        />
      )}

      {signatureTask && (
        <AgxColumn gap="spacing-xl" fill padding={{ bottom: 'spacing-8xl' }}>
          <AgxDivider variant="horizontal" />
          <AgxTypography size="large" type="title" id="part9SignaturesTitle">
            Part 9 Signatures
          </AgxTypography>
          <AgxRow
            gap="spacing-lg"
            justifyContent="space-between"
            alignItems="flex-start"
            fill
          >
            <AgxRow justifyContent="left" alignItems="flex-start">
              <AgxTypography
                id={'lbllicenseeDetails'}
                type={'body_ui'}
                size={'small'}
              >
                {signatureTask.name}
              </AgxTypography>
            </AgxRow>

            <AgxRow justifyContent="right" alignItems="flex-start">
              <AgxToggleSwitch
                id="step"
                checked={signatureTask.isCompleted ?? false}
                onChange={(isChecked: boolean) =>
                  updateTaskStep(signatureTask, isChecked)
                }
              />
            </AgxRow>
          </AgxRow>
        </AgxColumn>
      )}
    </AgxColumn>
  )
}

export default AgreementCommissionStageSteps
